import { useParams } from 'react-router-dom';

export const useHcoUrlParams = (suppressErrors: boolean = false) => {
	const { hcoId } = useParams<{ hcoId: string }>();

	if (!hcoId) {
		if (!suppressErrors) console.error('HCO ID is missing in the URL.');
		return { name: undefined, id: undefined };
	}

	const parts = hcoId.split('-');

	if (parts.length === 0) {
		if (!suppressErrors)
			console.error(
				'HCO ID format is invalid. Expected format: "name-id" or "id".'
			);
		return { name: undefined, id: undefined };
	}

	// The ID is the last part, everything before it forms the name
	const id = parts.pop()!;
	const name = parts && parts.length > 0 ? parts.join('-') : undefined;

	return {
		name: name
			? decodeURIComponent(name).split('-').join(' ').trim()
			: undefined,
		id: decodeURIComponent(id)
	};
};
